import { IOperatorStoreState } from './modules/OperatorsModule'
import { IStationStoreState } from './modules/StationsModule'
import { IUserStoreState } from './modules/UsersModule'
import Vue from 'vue'
import Vuex from 'vuex'
import { IBookingStoreState } from './modules/BookingsModule'

Vue.use(Vuex)

export interface IRootState {
  bookingModule: IBookingStoreState
  userModule: IUserStoreState
  stationModule: IStationStoreState
  operatorModule: IOperatorStoreState
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({})
